import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import CreatePropertyPage from './componance/pageMenu/CreatePropertyPage';
import LoginForm from './Authen/LoginForm';
import SignUpForm from './Authen/SignUpForm';
import EditProperty from './componance/pageMenu/EditProperty';
import DashboardAdmin from './DashboardAdmin';
import ForgotPasswordForm from './Authen/ForgotPasswordForm';
import ResetPasswordPage from './Authen/ResetPasswordPage';
import RentPage from './RentPage';
import BuyPage from './BuyPage';
import { AuthProvider } from './Authen/AuthContext';
import AdminRoute from './Authen/AdminRoute';
import TermsOfService from './componance/pageMenu/TermsOfService';
import PrivacyPolicy from './componance/pageMenu/PrivacyPolicy';
import SearchPage from './SearchPage';
import ReviewPage from './ReviewPage';
// ✅ Component สำหรับ Landing / Loading Page
function HomeWrapper() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000); // รอ 2 วินาที
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div style={{
        position: 'relative',
        width: '100vw',
        height: '100vh',
        backgroundColor: '#142438',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        {/* โลโก้ตรงกลาง */}
        <div style={{ width: '200px', maxWidth: '50vw' }}>
          <img
            src="/img/logo2.png"
            alt="Loading"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              objectFit: 'contain'
            }}
          />
        </div>
      </div>
    );
  }

  return <HomePage />;
}


function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomeWrapper />} />
          <Route path="/loginform" element={<LoginForm />} />
          <Route path="/signupform" element={<SignUpForm />} />
          <Route path="/forgot-password" element={<ForgotPasswordForm />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/rent" element={<RentPage />} />
          <Route path="/buy" element={<BuyPage />} />
          <Route path="/termofservice" element={<TermsOfService />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/reviewpage" element={<ReviewPage />} />

          {/* 🔐 Admin Routes */}
          <Route path="/dashboardadmin" element={<AdminRoute><DashboardAdmin /></AdminRoute>} />
          <Route path="/edit/:id" element={<AdminRoute><EditProperty /></AdminRoute>} />
          <Route path="/create" element={<AdminRoute><CreatePropertyPage /></AdminRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
